export class Pedidos {
  Payload: Payload;
}

export class Payload {
  OrderRef: string;
  Creation: Date;
  Items: Items[];
  loja: string;
}

export class Items {
  productRef: string;
  name: string;
  quantity: number;
}
